import ApplicationAdapter from 'lumen/adapters/application';

export default class MarketPerformanceDataItemAdapter extends ApplicationAdapter {
  pathForType(modelName: string): string {
    // Return as-is: pluralize would append 's' to the market ID in the typeKey
    return modelName;
  }
}
